<script>
import { mixins, HorizontalBar } from 'vue-chartjs'
const { reactiveProp } = mixins
var totalCounts = []
export default {
  extends: HorizontalBar,
  mixins: [reactiveProp],
  props: {
    chartData: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    },
    ticksMax: {
      type: Number
    },
    labelcount: {
      type: Number
    }
  },
  watch: {
    ticksMax() {
      this.$data._chart.options.scales.xAxes[0].ticks.max = this.ticksMax
      this.$data._chart.update()
    },
    labelcount(num) {
      this._data._chart.destroy()
      this.resizeRenderChart(num)
    }
  },
  methods: {
    resizeRenderChart(labelLen) {
      this.$refs.canvas.width = this.$refs.canvas.parentNode.clientWidth
      // 365px はチャートのデフォルトの高さです
      // 35 はチャートの上下のパディングです
      // 5 は、表示されているカテゴリの総数です
      // カテゴリーの高さ: 66px = (365 - 35) / 5
      // チャートの高さ = labelLen * カテゴリーの高さ + チャートの上下のパディングです
      this.$refs.canvas.height = labelLen * 66 + 35
      if (this.$refs.canvas.height < 365) {
        this.$refs.canvas.height = 365
        this.$refs.canvas.parentNode.style.overflow = 'hidden'
      }
      this.renderChart(this.chartData, this.options)
    }
  },
  mounted() {
    this.addPlugin({
      beforeRender(chart) {
        totalCounts = []
        // それぞれのトータル数値を取得
        chart.data.datasets.forEach((dataset, index) => {
          dataset.data.forEach((data, childIdx) => {
            index ? (totalCounts[childIdx] += data) : totalCounts.push(data)
          })
        })
      },
      // afterRender(chart) {
      afterDatasetsDraw(chart) {
        let taskCompleteCount = []
        let taskNonCompleteCount = []
        const isOrderTaskType = chart.data.datasets[0] && !chart.data.datasets[0].isNoWorkTaskType
        chart.data.datasets.forEach((dataset, index, arr) => {
          let canvas = document.getElementById('horizontalbar-chart')
          const totalCtx = canvas.getContext('2d')
          let meta = chart.getDatasetMeta(index)
          if (!meta.hidden) {
            meta.data.forEach(function(element, metaIdx) {
              const label = chart.data.labels[metaIdx]
              if (!label.length) return
              // positionの設定
              let position = element.tooltipPosition()
              // バーの最後にある最初のラベル
              if (index === arr.length - 2) {
                taskCompleteCount.push(dataset.data[metaIdx])
              }
              if (index === arr.length - 1) {
                taskNonCompleteCount.push(dataset.data[metaIdx])
              }
              if (index === arr.length - 1) {
                const taskTotalCount = totalCounts[metaIdx]
                totalCtx.beginPath()
                totalCtx.font = `${'14px'} "Helvetica Neue", Arial, sans-serif`
                totalCtx.fillStyle = '#252422'
                totalCtx.textAlign = 'left'
                let totalText = `${taskCompleteCount[metaIdx]}`
                if (isOrderTaskType) {
                  totalText = `${totalText}/${taskTotalCount}`
                }
                totalCtx.fillText(totalText,
                  position.x + 10,
                  position.y + 5
                )
                totalCtx.font = `${'12px'} "Helvetica Neue", Arial, sans-serif`
                totalCtx.fillStyle = '#fc0505'
                let numberLength = taskCompleteCount[metaIdx].toString().length + taskTotalCount.toString().length
                totalCtx.textAlign = 'left'
                if (isOrderTaskType && taskNonCompleteCount[metaIdx] !== 0) {
                  totalCtx.fillText(
                    `残 ${taskNonCompleteCount[metaIdx]}`,
                    position.x + 20 + (numberLength * 9),
                    position.y + 5
                  )
                }
                totalCtx.closePath()
              }
            })
          }
        })
      }
    })
    let labels = this.chartData ? this.chartData.labels.length : 0
    this.resizeRenderChart(labels)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/custom-components/HorizontalBar.vue